import { FormatMoneyAmount } from 'Assets/js/library/template-helpers'
import ExecuteGraphQlQuery from 'Assets/js/library/graphql.js'

export async function AddItemToCart({
  node,
  inputQuery,
  sections = 'cart-drawer',
}) {
  if (!node) {
    return null
  }

  const formData = new FormData(node)

  const id = formData.get('id')
  const quantity = formData.get('quantity') ?? 1
  const input = node.querySelector(inputQuery.replace('{id}', id))

  const properties = {}

  for (const [key, value] of formData.entries()) {
    if (key.includes('properties') && !!value) {
      const strippedKey = key.replace('properties[', '').replace(']', '')
      properties[strippedKey] = value
    }
  }

  const localizedPrice = FormatMoneyAmount(
    input.getAttribute('data-localized-price'),
  )

  properties._ORIGINAL_PRICE_LOCALIZED = localizedPrice
  if (input.hasAttribute('data-final-sale')) {
    properties._ASRC = 'Final Sale'
  }

  if (
    Shopify.currency.active === SAXX.Shop.ShopCurrency ||
    Number(Shopify.currency.rate) === 1
  ) {
    properties._ORIGINAL_PRICE = localizedPrice
  } else {
    // fetch base shop pricing here if needed
    const originalPrice = await ExecuteGraphQlQuery(
      `query getMultipleVariants($id: ID!) @inContext(country: ${SAXX.Shop.Country}) {
          node(id: $id) {
            ... on ProductVariant {
              id
              price {
                amount
              }
              compareAtPrice {
                amount
              }
            }
          }
        }`,
      { id: `gid://shopify/ProductVariant/${id}` },
      false,
    )

    if (originalPrice?.data?.node?.price?.amount) {
      properties._ORIGINAL_PRICE = FormatMoneyAmount(
        originalPrice?.data?.node?.compareAtPrice?.amount ??
          originalPrice?.data?.node?.price?.amount,
      )
    }
  }

  return fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{ id, quantity, properties }],
      sections,
    }),
  }).then((res) => res.json())
}

export function FetchCart(
  { priority = 'auto', ...headers } = { priority: 'auto' },
) {
  return fetch(`${window.Shopify.routes.root}cart.js`, {
    method: 'GET',
    credentials: 'include',
    priority,
    ...headers,
  }).then((res) => res.json())
}

export function UpdateCart(body, sections = 'cart-drawer') {
  return fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...body, sections }),
  }).then((res) => res.json())
}

export function UpdateItemInCart({
  id,
  quantity,
  sections = 'cart-drawer',
  ...details
}) {
  return fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id, quantity, sections, ...details }),
  }).then((res) => res.json())
}
